module.exports = __webpack_public_path__ + "img/editBtn.72493289.svg";